module.exports = __webpack_public_path__ + "img/faq-prego.adc6639a.png";